import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "pmco_cookie_consent_v1";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setVisible(false);
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "denied",
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 md:bottom-6 md:right-6 md:left-auto md:max-w-md z-[60] bg-[#1C1C1A] text-[#F7F5F0] p-5 md:p-6 rounded-xl shadow-2xl border border-[#F7F5F0]/10"
          data-testid="cookie-banner"
        >
          <div className="font-serif-display italic text-lg mb-2">
            A quick word on cookies
          </div>
          <p className="text-[13px] leading-relaxed text-[#F7F5F0]/80 mb-4">
            We use cookies for analytics (Google Analytics, PostHog) and
            advertising (Google AdSense). See our{" "}
            <a
              href="/privacy"
              className="underline hover:text-[#D93829]"
              data-testid="cookie-privacy-link"
            >
              privacy policy
            </a>
            .
          </p>
          <div className="flex items-center gap-3">
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="flex-1 bg-[#D93829] text-white text-[11px] uppercase tracking-[0.2em] font-semibold py-3 rounded-full hover:bg-[#F7F5F0] hover:text-[#1C1C1A] transition-colors duration-300"
            >
              Accept
            </button>
            <button
              onClick={reject}
              data-testid="cookie-reject"
              className="flex-1 bg-transparent border border-[#F7F5F0]/40 text-[#F7F5F0] text-[11px] uppercase tracking-[0.2em] font-semibold py-3 rounded-full hover:border-[#F7F5F0] transition-colors duration-300"
            >
              Reject
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
